module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 p-5"
  }, [_c('div', {
    staticClass: "listTitle p-2"
  }, [_vm._v("REM3RCH UPDATES")]), _vm._v(" "), _vm._l((_vm.getVersioningsCurrent), function(versioning) {
    return _c('div', {
      staticClass: "content-versioning-update"
    }, [_c('div', {
      staticClass: "listTitle"
    }, [_vm._v(_vm._s(versioning.version) + " - " + _vm._s(versioning.name.toUpperCase()))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "html-safe",
        rawName: "v-html-safe",
        value: (_vm.nl2br(versioning.description)),
        expression: "nl2br(versioning.description)"
      }],
      staticClass: "p-3"
    }), _vm._v(" "), _c('p', {
      staticClass: "content-date"
    }, [_vm._v("RELEASE DATE " + _vm._s(versioning.versioningDate))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-5 p-3"
  }, [_c('div', {
    staticClass: "listTitle"
  }, [_vm._v("UPCOMING UPDATES")]), _vm._v(" "), _vm._l((_vm.getVersioningsUpcoming), function(versioning) {
    return _c('div', {
      staticClass: "content-versioning-upcoming"
    }, [_c('div', {
      staticClass: "listTitle"
    }, [_vm._v(_vm._s(versioning.name.toUpperCase()))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "html-safe",
        rawName: "v-html-safe",
        value: (_vm.nl2br(versioning.description)),
        expression: "nl2br(versioning.description)"
      }],
      staticClass: "p-3 content-description"
    })])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fbc1b2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/versioning/Versionings.vue
// module id = 3069
// module chunks = 0